import { CLOSE_MODAL } from "../actions/ActionConstant";
import { TOGGLE_MODAL } from "../actions/ActionConstant";
import { OPEN_MODAL } from "../actions/ActionConstant";
import {
  SHOW_ERROR_COMPONENT,
  HIDE_ERROR_COMPONENT
} from "../actions/ActionConstant";

const initialState = {
  errorComponent: {
    show: false,
    data:null
  }
};

const ComponentReducer = (state = initialState, action) => {
  switch (action.type) {   
    case SHOW_ERROR_COMPONENT:
      return {
        ...state,
        errorComponent: {
          show: true,
          data: action.data
        },
      };
    case HIDE_ERROR_COMPONENT:
      return {
        ...state,
        errorComponent: {
          show: false,
          data: null
        },
      };
    default:
      return state;
  }
};

export default ComponentReducer;
